import React from "react";
import { Card, Typography, CardContent } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Moment from "moment";
import CircularWeightBar from "./CircularWeightBar";

export class CartoneroDashboard extends React.Component {
  render() {
    const { user } = this.props;
    const weightGoal = 600;
    const styles = {
      circularWeightBar: {
        maxWidth: "250px",
        marginLeft: "20px"
      },
      listValue: {
        color: "#666"
      }
    };

    return (
      <Card>
        <CardContent>
          <Grid>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <Typography variant="display1">Acumulado del mes</Typography>
              </Grid>
              <Grid container spacing={24} direction="row" alignItems="center">
                <Grid item xs={6} sm={4}>
                  <div style={styles.circularWeightBar}>
                    <CircularWeightBar
                      value={user.pesajes.acumuladoMensual}
                      max={weightGoal}
                      {...this.props}
                    />
                  </div>
                </Grid>
                <Grid item xs={6} sm={8}>
                  <Typography variant="headline">Meta</Typography>
                  <Typography variant="display2">{weightGoal} Kg.</Typography>
                  {user.pesajes.acumuladoMensual >= weightGoal ? (
                    <Typography variant="headline" style={{ color: "#7CB342" }}>
                      ¡Meta Alcanzada!
                    </Typography>
                  ) : (
                    <Typography variant="headline" color="error">
                      Faltan {weightGoal - user.pesajes.acumuladoMensual}kgs.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <List>
          <Divider component="li" variant="inset" />
          <ListItem>
            <ListItemText
              primary="Último registro"
              secondary={Moment(user.pesajes.fechaHora).fromNow()}
            />
            <Typography variant="display1">{user.pesajes.diario} kgs.</Typography>
          </ListItem>
          <Divider component="li" variant="inset" />
          <ListItem>
            <ListItemText primary="Acumulado del último mes" />
            <Typography variant="body2">
              {user.pesajes.totalMesAnterior} kgs.
            </Typography>
          </ListItem>
          <Divider component="li" variant="inset" />
        </List>
        <CardContent>
          <Typography variant="headline">Historial de registros</Typography>
          <List>
            <Divider component="li" variant="inset" />
            {user.pesajes.pesajesList &&
              user.pesajes.pesajesList.map(value => (
                <ListItem>
                  <ListItemText
                    primary={Moment(value.fecha).format("DD/MM/YYYY")}
                    secondary={`Etapa/ruta: ${value.etapa} - Bolsón: ${
                      value.bolson
                    }`}
                  />
                  <ListItemSecondaryAction style={styles.listValue}>
                    <strong>{value.peso}</strong> kgs.
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
          </List>
        </CardContent>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DashboardCartoneros/Cartonero.js